import React, { useContext, useMemo, useState } from 'react';
import {
  EditSceneModalZoomContextType,
  EditSceneModalZoomProviderProps,
} from './types';

const EditSceneModalZoomContext = React.createContext<
  EditSceneModalZoomContextType | undefined
>(undefined);

export const EditSceneModalZoomProvider: React.FC<EditSceneModalZoomProviderProps> = ({
  children,
}) => {
  const [zoomSliderRef, setZoomSliderRef] = useState<HTMLDivElement>(null);

  return (
    <EditSceneModalZoomContext.Provider
      value={useMemo(() => ({ zoomSliderRef, setZoomSliderRef }), [
        zoomSliderRef,
        setZoomSliderRef,
      ])}
    >
      {children}
    </EditSceneModalZoomContext.Provider>
  );
};

export function useEditSceneModalZoomContext(): EditSceneModalZoomContextType {
  const context = useContext(EditSceneModalZoomContext);

  if (!context) {
    throw new Error(
      'useEditSceneModalZoomContext must be used within a EditSceneModalZoomProvider',
    );
  }

  return context;
}
